import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  padding: 6px ', 'px;\n'], ['\n  padding: 6px ', 'px;\n']);

import styled from 'styled-components';

import { gridSize } from '@atlaskit/theme';

var NoMatches = styled.div(_templateObject, gridSize() * 3);

export default NoMatches;